<script>
  import { onMount } from 'svelte';
  import * as d3 from 'd3';
  import { get_absolute_coord } from './helper.js'
  import { gen_skeleton } from './FrameView.js'
  import { gen_header, gen_background, set_view_size, gen_frame_number } from './OverlapView.js'

  // Export let name
  let overlapView = undefined
  let overlap_header = undefined
  let overlap_background = undefined
  let overlap_skeleton = undefined

  // Draw overlap view
  onMount(async() => {

    // Overlap view components
    overlap_header = d3.select(overlapView).select('.pose-view-header')
    overlap_background = d3.select(overlapView).select('.pose-view-bg')
    overlap_skeleton = d3.select(overlapView).select('.pose-view-skeleton')

    // Generate header
    gen_header(overlap_header)

    // Add background video
    gen_background(overlap_background, overlap_header)

    // Add frame number below the view
    gen_frame_number(overlap_header)

    // Set overlap view size
    set_view_size(overlap_header)
  })
  
</script>

<style>
  #overlap-view {
    text-align: left;
    margin: 10px;
    display: inline-block;
  }

  .pose-view-header {
    font-size: 16px;
  }

  .pose-view-header-rect {
    fill: 'black';
    rx: 5px;
    ry: 5px;
    height: 2rem;
    width: 10px;
  }
</style>

<div id='overlap-view' class='pose-view' bind:this={overlapView}>
  <svg id='overlap-view-svg' class='pose-view-svg'>
    <g id='overlap-view-header' class='pose-view-header'>
      <rect id='overlap-view-header-rect' class='pose-view-header-rect'></rect>
    </g>
    <g id='overlap-view-bg' class='pose-view-bg'></g>
    <g id='overlap-view-skeleton' class='pose-view-skeleton'></g>
  </svg>
</div> 

